import { render, staticRenderFns } from "./BotaoNovo.vue?vue&type=template&id=1e2e5184"
import script from "./BotaoNovo.vue?vue&type=script&lang=js"
export * from "./BotaoNovo.vue?vue&type=script&lang=js"
import style0 from "./BotaoNovo.vue?vue&type=style&index=0&id=1e2e5184&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports